import { ActionIcon, Card, Group, Stack } from '@mantine/core';
import { useNavigate } from 'react-router';
import { PageTemplate } from '../../../../api/pages-client/pages-client.type';
import { useTranslation } from 'react-i18next';
import { Icon } from '../../../../ui-library/icon/icon';
import { Tooltip } from '../../../../ui-library/tooltip/tooltip';
import { Text } from '../../../../ui-library/typography/typography';
import { ComponentPreview } from '../dashboards-list/component-preview';
type Props = {
  template: PageTemplate;
  onEdit: (template: PageTemplate) => void;
  onDelete: (template: PageTemplate) => void;
};

export const DashboardTemplateListItem = ({ template, onEdit, onDelete }: Props) => {
  const i18n = useTranslation();
  const navigate = useNavigate();
  const handleEdit = () => {
    onEdit(template);
  };

  const handleDelete = () => {
    onDelete(template);
  };

  return (
    <Card shadow="sm" radius="md" withBorder h={180} style={{ display: 'flex', flexDirection: 'column' }}>
      <Group justify="space-between" align="flex-start" wrap="nowrap" mb={10}>
        <Stack style={{ flex: 1, minWidth: 0 }}>
          <Group justify="space-between" align="flex-start" wrap="nowrap">
            <Group gap="sm">
              <Text
                weight="bold"
                size="large"
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  maxWidth: '100%',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  navigate(`/application/dashboards/template/${template.id}`);
                }}
              >
                {template.name}
              </Text>
              {template.description && (
                <Tooltip label={template.description} variant="black" multiline style={{ maxWidth: 300 }} zIndex={1000}>
                  <Icon name="info" size={20} />
                </Tooltip>
              )}
            </Group>
            <Group gap="sm">
              <Tooltip label={`Edit ${i18n.t('common.dashboard.template')}`} variant="black">
                <ActionIcon variant="subtle" onClick={handleEdit}>
                  <Icon name="edit" size={20} style={{ cursor: 'pointer' }} />
                </ActionIcon>
              </Tooltip>
              <Tooltip label={`Delete ${i18n.t('common.dashboard.template')}`} variant="black">
                <ActionIcon variant="subtle" onClick={handleDelete}>
                  <Icon name="delete" size={20} style={{ cursor: 'pointer' }} />
                </ActionIcon>
              </Tooltip>
            </Group>
          </Group>
        </Stack>
      </Group>
      <div
        style={{
          width: '100%',
          height: '100%',
          overflow: 'auto',
          position: 'relative',
          padding: '4px',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          display: 'grid',
          // grammar-check disable-next-line ENGLISH_WORD_REPEAT_RULE
          gridTemplateColumns: '1fr 1fr',
          gap: '8px',
          alignContent: 'start',
        }}
      >
        {template.config.components?.map((component, index) => {
          return <ComponentPreview key={`${component.id}-${index}`} component={component} />;
        })}
        {template.config.data_entry_components?.map((dataEntryComponent, index) => {
          return <ComponentPreview key={`${dataEntryComponent.id}-${index}`} dataEntryComponent={dataEntryComponent} />;
        })}
      </div>
    </Card>
  );
};
